// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"2ff7a853","116":"6055fbd1","234":"ffa103ab","281":"8f7ee971","321":"66b5ee55","333":"fddd4d7a","469":"fcc7a137","650":"1c0e0f4a","692":"8aacddc3","757":"aa9afa43","805":"7f713ffa","874":"23e9b95a","888":"6cf67a81"}[chunkId] + ".chunk.js";
};